import CriteriaSection from './CriteriaSection'

export default CriteriaSection
